import { container, inject, injectWithTransform, singleton } from "tsyringe";
import { ConsentProviderInterface } from "./consentProviders/consent-provider-interface";
import { Geo, Logger, LoggerTransformer } from "@identity/utils";
import { OneTrust } from "./consentProviders/one-trust";
import { gdprCountries } from "../../utils/gdpr-countries";
import { TcfApi } from "./consentProviders/tcf-api";
import { Consents } from "./types";
import { UspApi } from "./consentProviders/usp-api";

@singleton()
export class ConsentProviderFactory {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(Geo) private geo: Geo,
  ) {}

  private consentProvider: ConsentProviderInterface;

  public get(fandom1TEnabled = false): Promise<Consents> {
    const location = this.geo.getCountryCode();
    this.logger.info("Location: ", location);
    if (location) {
      if (location === "us") {
        this.logger.info("CCPA location");
        this.consentProvider = container.resolve(UspApi);
      } else if (gdprCountries.includes(location)) {
        this.consentProvider = container.resolve(TcfApi);
        this.logger.info("__tcfapi installed");
      } else {
        this.logger.info("Privacy policy is not required");
        return Promise.resolve({
          gdprConsent: true,
          geoRequiresSignal: false,
          geoRequiresConsent: false,
          ccpaSignal: false,
        });
      }
    }
    if (!fandom1TEnabled) {
      return;
    }
    const oneTrustFallback = container.resolve(OneTrust);
    this.logger.info("OneTrust installed");

    const constQuery: Promise<Consents>[] = [oneTrustFallback.consentGiven];
    this.consentProvider
      ? constQuery.push(this.consentProvider.consentGiven)
      : null;

    return Promise.race(constQuery);
  }
}
